import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";

interface State {
  type: 'imagen' | 'ofuscado',
  value: string
}

@Component({
  selector: "app-camara-controls",
  templateUrl: "./camara-controls.component.html",
  styleUrls: ["./camara-controls.component.css"],
})
export class CamaraControlsComponent {
  activeArrowBtn = false
  showBackgroundControls: boolean
  disabledOfuscadoBtn = true
  disabledImagenBtn = true

  imagenValueBtns = [ 'fondo-1.png', 'fondo-2.png' ]
  ofuscadoValueBtns = [ 'low', 'high' ]

  state: { type: 'imagen' | 'ofuscado', value: string } = null

  @ViewChild('imagenValues', { static: false }) imagenValues: ElementRef<HTMLDivElement>
  @ViewChild('ofuscadoValues', { static: false }) ofuscadoValues: ElementRef<HTMLDivElement>

  @Input() camOpen: boolean = true
  @Input() isMedic: boolean

  @Output() toogleCam: EventEmitter<boolean> = new EventEmitter()
  @Output() changeBackgroundEffect: EventEmitter<State> = new EventEmitter()

  show() {
    this.toogleCam.emit(!this.camOpen)
  }

  displayCamMenu() {
    this.activeArrowBtn = !this.activeArrowBtn
    this.showBackgroundControls = !this.showBackgroundControls
  }

  private toogleDisabledBtn(type: 'imagen' | 'ofuscado') {
    if (type === 'imagen') {
      this.disabledImagenBtn = !this.disabledImagenBtn
    } else {
      this.disabledOfuscadoBtn = !this.disabledOfuscadoBtn
    }
  }

  private manageStylesOfFondoBtn(type: 'imagen' | 'ofuscado') {
    if (type === 'imagen') {
      if (!this.disabledImagenBtn) {
        this.toogleDisabledBtn(type)
        Array.from(this.imagenValues.nativeElement.children).forEach(btn => btn.classList.add('disable'))
        return
      }

      this.disabledOfuscadoBtn = true
      Array.from(this.ofuscadoValues.nativeElement.children).forEach((child: HTMLButtonElement) => child.classList.add('disable'))

      Array.from(this.imagenValues.nativeElement.children)[0].classList.remove('disable')
    } else {
      if (!this.disabledOfuscadoBtn) {
        this.toogleDisabledBtn(type)
        Array.from(this.ofuscadoValues.nativeElement.children).forEach(btn => btn.classList.add('disable'))
        return
      }

      if (this.imagenValues) {
        this.disabledImagenBtn = true
        Array.from(this.imagenValues.nativeElement.children).forEach((child: HTMLButtonElement) => child.classList.add('disable'))
      }

      Array.from(this.ofuscadoValues.nativeElement.children)[0].classList.remove('disable')
    }

    this.toogleDisabledBtn(type)
  }

  clickFondoBtn(type: 'imagen' | 'ofuscado') {
    this.manageStylesOfFondoBtn(type)

    let valueToEmit: State = { type, value: '' }
    let enabledBtn = null

    if (type === 'imagen') {
      if (!this.disabledImagenBtn) {
        enabledBtn = Array.from(this.imagenValues.nativeElement.children).filter(btn => !btn.classList.contains('disable'))[0]
      }
    } else {
      if (!this.disabledOfuscadoBtn) {
        enabledBtn = Array.from(this.ofuscadoValues.nativeElement.children).filter(btn => !btn.classList.contains('disable'))[0]
      }
    }

    valueToEmit.value = enabledBtn == null ? '' : (enabledBtn as HTMLButtonElement).value

    this.changeBackgroundEffect.emit(valueToEmit)

    this.changeState(valueToEmit)
  }

  private manageStylesOfBtnValue(type: 'imagen' | 'ofuscado', btn: HTMLButtonElement) {
    let restOwnValues: HTMLButtonElement[] = []

    if (type === 'imagen') {
      this.disabledOfuscadoBtn = true
      Array.from(this.ofuscadoValues.nativeElement.children).forEach((child: HTMLButtonElement) => child.classList.add('disable'))

      const rest = Array.from(this.imagenValues.nativeElement.children).filter((child: HTMLButtonElement) => child.value !== btn.value)
      restOwnValues = rest as HTMLButtonElement[]

      if (this.disabledImagenBtn) this.disabledImagenBtn = false
    } else {
      if (this.imagenValues) {
        this.disabledImagenBtn = true
        Array.from(this.imagenValues.nativeElement.children).forEach((child: HTMLButtonElement) => child.classList.add('disable'))
      }

      const rest = Array.from(this.ofuscadoValues.nativeElement.children).filter((child: HTMLButtonElement) => child.value !== btn.value)
      restOwnValues = rest as HTMLButtonElement[]

      if (this.disabledOfuscadoBtn) this.disabledOfuscadoBtn = false
    }

    btn.classList.toggle('disable')
    restOwnValues.forEach((child: HTMLButtonElement) => child.classList.add('disable'))
  }

  clickBtnValue(type: 'imagen' | 'ofuscado', btn: HTMLButtonElement) {
    this.manageStylesOfBtnValue(type, btn)

    if (this.state != null && btn.value === this.state.value) return

    const valueToEmit: State = { type, value: btn.value }

    this.changeBackgroundEffect.emit(valueToEmit)

    this.changeState(valueToEmit)
  }

  private changeState(newState: State) {
    this.state = {...newState}
  }
}